var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGoogleMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.686 17.057a20.38 20.38 0 011.666 2.445c.425.8.6 1.34.916 2.307.184.53.36.691.73.691.402 0 .587-.27.728-.69.295-.908.523-1.599.883-2.257 1.39-2.599 3.655-4.445 4.93-6.975 0 0 .84-1.545.84-3.71 0-2.017-.828-3.419-.828-3.419l-9.86 11.625-.005-.017z",
    fill: "#34A853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34 12.304c.795 1.795 2.31 3.368 3.345 4.753l5.481-6.445s-.774 1.005-2.172 1.005c-1.558 0-2.827-1.23-2.827-2.786 0-1.07.643-1.812.643-1.812C5.776 7.613 6 8.583 5.328 12.3l.012.003z",
    fill: "#FBBC04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.236 1.837c1.827.583 3.379 1.812 4.31 3.607l-4.379 5.18s.643-.745.643-1.812c0-1.588-1.351-2.787-2.81-2.787-1.384 0-2.172.994-2.172.994.336-.76 3.81-4.924 4.413-5.18l-.005-.002z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34 4.116C7.43 2.83 9.34 1.5 11.977 1.5c1.274 0 2.24.335 2.24.335l-4.395 5.18c-.296-.16-3.19-2.393-3.482-2.906v.007z",
    fill: "#1A73E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34 12.304S4.62 10.89 4.62 8.851c0-1.932.762-3.624 1.724-4.718l3.482 2.906-4.482 5.265H5.34z",
    fill: "#EA4335"
  })));
}

export default SvgIconGoogleMap;